import {PortExposureBodyChunk} from "../../chunks/types/PortExposureBodyChunk";
import {PortDirection} from "../types/PortDirection";
import { getPortDirectionFromChildPortChunk } from "./getPortDirectionFromChildPortChunk";

export function getPortDirectionFromPortExposureBodyChunk(
  portExposuresBodyChunk: PortExposureBodyChunk
): PortDirection {
  const {
    captures: {
      1: childPortChunk
    }
  } = portExposuresBodyChunk;
  return getPortDirectionFromChildPortChunk(childPortChunk);
}
